import { GuideModel, Guides } from "@/data/providers/global-provider";

export class GuidesState {
	public guides: Guides | undefined;
	public selectedGuide: GuideModel | undefined;
	public platform: string = "all";
	public difficulty: string = "all";
}